import {
  ConfirmedAccess,
  UserWithRelations,
  UserWithRole,
  WithoutPermission,
  WithoutRestriction,
  WithPermission,
  WithRestriction,
} from '@utilities-one/api-sdk';

import { mergePermissions } from '@/entities/user/utils/mergePermissions';
import { hasTruthyProperty } from '@/library/lang/objects';

export const hasPermission = (user: UserWithRole, ...permissions: string[]): boolean => {
  const mergedPermissions = mergePermissions(user);
  return permissions.some((permission) => hasTruthyProperty(mergedPermissions, permission));
};

export const hasAccess = (
  confirmedAccess: Pick<ConfirmedAccess, 'id' | 'name' | 'isConfirmed'>[],
  accessKey: string
) => {
  return confirmedAccess.some((userAccess) => userAccess.name === accessKey && userAccess.isConfirmed);
};

export const filterByPermissions = <T>(user: UserWithRole, list: WithPermission<T>[]): WithoutPermission<T>[] => {
  return list
    .filter(
      ({ permission }) => !permission || hasPermission(user, ...(Array.isArray(permission) ? permission : [permission]))
    )
    .map(({ permission, ...item }) => {
      const newItem: WithoutPermission<T> = { ...item } as WithoutPermission<T>;

      // @ts-expect-error
      if (item.items) {
        // @ts-expect-error
        const filteredChildren = filterByPermissions(user, item.items);
        if (filteredChildren.length > 0) {
          // @ts-expect-error
          newItem.items = filteredChildren;
        } else {
          // @ts-expect-error
          delete newItem.items;
        }
      }

      return newItem;
    });
};

export const filterByRestrictions = <T>(
  user: UserWithRelations,
  list: WithRestriction<T>[]
): WithoutRestriction<T>[] => {
  return list
    .filter(({ restriction }) => !restriction || restriction(user))
    .map(({ restriction, ...item }) => {
      const newItem: WithoutRestriction<T> = { ...item } as WithoutRestriction<T>;
      // @ts-expect-error
      if (item.items) {
        // @ts-expect-error
        const filteredChildren = filterByRestrictions(user, item.items);
        if (filteredChildren.length > 0) {
          // @ts-expect-error
          newItem.items = filteredChildren;
        } else {
          // @ts-expect-error
          delete newItem.items;
        }
      }

      return newItem;
    });
};
